import { render, staticRenderFns } from "./Lesson.vue?vue&type=template&id=7aca1efa&scoped=true&"
import script from "./Lesson.vue?vue&type=script&lang=ts&"
export * from "./Lesson.vue?vue&type=script&lang=ts&"
import style0 from "./Lesson.vue?vue&type=style&index=0&id=7aca1efa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aca1efa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7aca1efa', component.options)
    } else {
      api.reload('7aca1efa', component.options)
    }
    module.hot.accept("./Lesson.vue?vue&type=template&id=7aca1efa&scoped=true&", function () {
      api.rerender('7aca1efa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/courses/CoursePage/components/Lesson.vue"
export default component.exports